const PUBLIC_SITE_URL = import.meta.env.VITE_PUBLIC_SITE_URL as string | undefined;

export function authRedirectUrl(path = '/'): string {
  return buildAuthRedirectUrl(path, PUBLIC_SITE_URL, window.location.origin);
}

export function buildAuthRedirectUrl(
  path = '/',
  configuredSiteUrl?: string,
  currentOrigin?: string,
): string {
  const origin = normalizeOrigin(configuredSiteUrl)
    ?? normalizeOrigin(currentOrigin)
    ?? 'http://localhost';
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${origin}${normalizedPath}`;
}

function normalizeOrigin(value: string | undefined): string | null {
  const trimmed = value?.trim();
  if (!trimmed) return null;

  try {
    const url = new URL(trimmed);
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return null;
    return url.origin;
  } catch {
    return null;
  }
}
